"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = void 0;
const Props_1 = require("../../shared/Props");
const getColor = ({ $color, }) => {
    if ((0, Props_1.isGreyscaleColor)($color)) {
        return `var(--ds-color-${$color})`;
    }
    if ($color === "blue" || $color === "red" || $color === "green") {
        return `var(--ds-color-${$color}-100)`;
    }
    return "inherit";
};
exports.getColor = getColor;
//# sourceMappingURL=Text.utils.js.map